/* eslint-disable import/prefer-default-export */

// eslint-disable-next-line no-unused-vars
export const permissionChecker = (role, permissions, scope = null) => (needle) => {
    if (role === 'admin' || scope === 'homeport') return true;
    const permArray = permissions.split(',');
    return permArray.find((p) => p === needle);
};
